/* ************************* */
//
// Dreamcoat Password Reset Request
// This file will be made available as /assets/dreamcoat/password-reset-request.js by webpack
//
/* ************************* */

const { paths, urls } = require("@root/sugarconfig");
const {
    getParamsFromQuery,
    postAsyncJSON,
} = require("@sugarfrontend/modules/shared");
const { contactFormParams } = require("@sugarfrontend/modules/clicks");
const {
    isValidEmail,
    updateButtonState,
    showAlertBox,
    hideAlertBox,
    recaptchaV3Ping,
} = require("./utils");

// DOM Elements
let emailInputEl = null,
    submitBtn = null,
    submitLabelEl = null,
    stepForm = null,
    stepSuccess = null,
    contactSupportLink = null;

$(document).ready(function () {
    recaptchaV3Ping("password_reset_request_view");

    // Initialize DOM elements
    emailInputEl = $("#inputEmail");
    submitBtn = $("#submit-button");
    submitLabelEl = $("#submit-label-span");
    stepForm = $("#step-form");
    stepSuccess = $("#step-success");
    contactSupportLink = $("#contact-support-link");

    // Event Listeners
    contactSupportLink.on("click", contactSupportClicked);
    emailInputEl.on("keyup", emailInputChanged);
    emailInputEl.on("keypress", function (e) {
        if (e.which === 13) {
            e.preventDefault();
            submitBtn.click();
        }
    });

    submitBtn.on("click", handleSubmit);

    // Pre-fill email from query params
    const params = getParamsFromQuery(document.location.search);
    if (params.email && params.email.trim().length > 0) {
        emailInputEl.val(params.email);
    }

    // Handle reason param to show message
    const reason = params.reason;
    let message = "";

    switch (reason) {
        case "fb":
            message =
                "We no longer support Facebook login, you must reset your password to continue using SugarWOD! After doing this, the next time you login to SugarWOD you must use your email + password to login.";
            break;
    }

    if (message.length > 0) {
        showMessage(message);
    }

    // Initial state
    emailInputChanged();
});

// Handle Submit button click
function handleSubmit() {
    const email = emailInputEl.val().trim().toLowerCase();

    if (!isValidEmail(email)) {
        showMessage("Please enter a valid email address.");
        return;
    }

    hideMessage();
    updateSubmitButtonView("working");

    // Send password reset request
    postAsyncJSON(
        paths.public_api_prefix + "/forgotpassword",
        { email: email },
        "",
        function (response) {
            if (response.success) {
                // Show success step
                showSuccessStep();
            } else {
                showMessage(
                    response.message || "An error occurred. Please try again."
                );
                updateSubmitButtonView("ready");
            }
        },
        function (error) {
            const message =
                error.message || "An error occurred. Please try again.";
            showMessage(message);
            updateSubmitButtonView("ready");
        }
    );
}

// Show success step
function showSuccessStep() {
    stepForm.removeClass("active");
    stepSuccess.addClass("active");
}

// Input change handler
function emailInputChanged() {
    const email = emailInputEl.val().trim();
    submitBtn.prop("disabled", email.length < 5 || !isValidEmail(email));
}

// Button view updates
function updateSubmitButtonView(state) {
    updateButtonState(submitBtn, submitLabelEl, state, emailInputChanged);
}

// Message display (box error at top)
function showMessage(msg) {
    hideMessage();
    showAlertBox("alert-container", "error", msg);
}

function hideMessage() {
    hideAlertBox();
}

// Contact support click handler
function contactSupportClicked(e) {
    e.preventDefault();
    const email = emailInputEl.val().trim();
    const requestMessage =
        "Please give us any information that might help us find your account, including past email(s) you've used, gyms where you were a member, etc.";
    window.location.href =
        urls.contact_form +
        contactFormParams(
            "Trouble Accessing My Account",
            null,
            email,
            null,
            requestMessage
        );
}
